module.exports = __webpack_public_path__ + "img/factory-background.bb1e1e23.bb1e1e23.jpg";